import { Injectable } from "@angular/core";

import { SocketService } from "../socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { debug } from "@helpers/debug";
import { DerivativeService } from "./derivative.service";
import { Stock } from "@models/derivative/currencies/stock";

@Injectable({
	providedIn: "root"
})
export class StockService extends DerivativeService<Stock> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, translationService, socketService, "StockService");
	}

	public logoUrl(item: Stock, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "stocks/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "stocks/stocks-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to stock updates");
		}

		const priceRoom = {
			room: "stock_prices",
			collection: "stocks",
			type: Stock,
			isPrivate: false
		};
		const tradableRoom = {
			room: "stocks",
			collection: "stocks",
			type: Stock,
			isPrivate: false
		};
		this.initSockets(priceRoom, tradableRoom);
	}
}
